import { render } from "./SideMenuManger.vue?vue&type=template&id=0548e0e6&scoped=true"
import script from "./SideMenuManger.vue?vue&type=script&lang=js"
export * from "./SideMenuManger.vue?vue&type=script&lang=js"

import "./SideMenuManger.vue?vue&type=style&index=0&id=0548e0e6&scoped=true&lang=css"

import exportComponent from "/Users/hooeni/Workspace/nodebee_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0548e0e6"]])

export default __exports__